import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/reducers';

export interface CancelMissionState {
    confirmationDialogOpen: boolean;
    isAwaitingResponse: boolean;
}

const initialState: CancelMissionState = {
    confirmationDialogOpen: false,
    isAwaitingResponse: false,
};

export const cancelMissionSlice = createSlice({
    name: 'cancelMission',
    initialState,
    reducers: {
        setConfirmationDialogOpen: (state: CancelMissionState, action: PayloadAction<boolean>) => {
            state.confirmationDialogOpen = action.payload;
        },
        setIsAwaitingResponse: (state: CancelMissionState, action: PayloadAction<boolean>) => {
            state.isAwaitingResponse = action.payload;
        },
    },
});

export const { setConfirmationDialogOpen, setIsAwaitingResponse } = cancelMissionSlice.actions;

export const getConfirmationDialogOpen = (state: RootState) => state.cancelMission.confirmationDialogOpen;
export const getIsAwaitingResponse = (state: RootState) => state.cancelMission.isAwaitingResponse;

export default cancelMissionSlice.reducer;
